import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { controlToastState, Modal, Select } from "risa-oasis-ui_v2";
import { updateCmmInputTableData } from "../../../api/bigQuery/nycbsPharmaOrders";
import { updateOrder } from "../../../redux/slice/nycbsPharmaExternal/nycbsPharmaOrder";
import { AppDispatch, RootState } from "../../../redux/store/store";
import { generateFullName } from "../../../utils/generateOrderDataForTable";

interface NewAssignModalProps {
  onClose: () => void;
  assignedTo: string;
  orderId: string;
  assignedToId: string;
}

const NewAssignModal = (props: NewAssignModalProps) => {
  const [providerId, setProviderId] = useState("");
  const [loading, setLoading] = useState(false);
  const { data: providersDetails } = useSelector(
    (state: RootState) => state.allProviders,
  );
  const dispatch = useDispatch<AppDispatch>();
  const options = providersDetails?.map((provider) => {
    return {
      value: provider?.DocID || "",
      label: generateFullName(
        provider.FirstName || "",
        "",
        provider?.LastName || "",
      ),
    };
  });

  const onSelctedOptionChange = (data) => {
    setProviderId(data.value);
  };

  const onUpdateAssignee = async () => {
    //TODO : Add global error handler
    setLoading(true);
    try {
      const result = await updateCmmInputTableData(
        "identifier",
        props.orderId,
        [
          {
            field: "assignee_id",
            value: providerId ?? "",
          },
        ],
      );
      dispatch(updateOrder(props.orderId, result["details"][0]));
      controlToastState("assignee-changed-success");
    } catch (error) {
      controlToastState("assignee-changed-failure");
    } finally {
      props.onClose();
      setLoading(false);
    }
  };

  return (
    <Modal
      dialogId={"nycbs-reAssign"}
      onSave={onUpdateAssignee}
      title={
        props?.assignedToId !== "" ? "Re-assign the auth" : "Assign the auth"
      }
      saveButtonText={loading ? "Updating..." : "Save"}
      cancelText={"Cancel"}
      onClose={props.onClose}
      disableSave={providerId === "" || loading}
    >
      <div className="assign-auth-container flex flex-col gap-3">
        <div className="assign-auth--assigned-to rounded bg-primaryGray-16 p-2 text-tiny font-normal">
          {props?.assignedToId !== "" ? (
            <>
              This auth is assigned to{" "}
              <span className="font-bold">{props.assignedTo}</span>
            </>
          ) : (
            <>
              This Auth is <span className="font-bold">Unassigned</span>
            </>
          )}
        </div>
        <div className="assigned-to-dropdown">
          <Select
            id={"reassign-to-nycbs"}
            onOptionChange={onSelctedOptionChange}
            label={props?.assignedToId !== "" ? "Re-assign to" : "Assign to"}
            placeholder={"Select Member"}
            defaultValue={props.assignedToId}
            options={options || []}
          />
        </div>
      </div>
    </Modal>
  );
};

export default NewAssignModal;
